var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8158 3.61771C29.6132 9.12074 26.5439 15.8438 20.9598 18.635C15.3758 21.4263 9.39273 19.2282 7.59534 13.7252L0.52735 17.2582C3.58149 26.609 13.7498 30.3446 23.2382 25.6017C32.7266 20.8588 37.9429 9.43296 34.8887 0.082197L27.8158 3.61771Z",
    fill: "#6CC04A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterRight);
export default __webpack_public_path__ + "static/media/footer-right.0e9a6117c3a48d8a5f553498d988ca0d.svg";
export { ForwardRef as ReactComponent };